export default __webpack_public_path__ + "media/images/react_icons/search_circle-cdf63d7b4230dfb456609a68c6ee1237.svg";